import Entities from 'STORE';

export function resetLinkPreviewProcess(groupId: string): void {
  const inputPanel = Entities.InputPanelsStore.getById(groupId);

  if (!inputPanel) {
    return;
  }

  inputPanel.setLink(null);
  inputPanel.linkPreviews.clear();
  inputPanel.setIsShowLinkPreview(false);
  inputPanel.setIsLinkPreviewCancelled(false);
}
